import script from "./CreateOrganizationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrganizationModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateOrganizationModal.vue?vue&type=style&index=0&id=ce8ccf52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8ccf52"]])

export default __exports__